/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategoryDto
 */
export interface CategoryDto {
    /**
     * 
     * @type {string}
     * @memberof CategoryDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof CategoryDto
     */
    code?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CategoryDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategoryDto
     */
    parentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategoryDto
     */
    parentName?: string | null;
}

/**
 * Check if a given object implements the CategoryDto interface.
 */
export function instanceOfCategoryDto(value: object): value is CategoryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CategoryDtoFromJSON(json: any): CategoryDto {
    return CategoryDtoFromJSONTyped(json, false);
}

export function CategoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'description': json['description'] == null ? undefined : json['description'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'parentName': json['parentName'] == null ? undefined : json['parentName'],
    };
}

export function CategoryDtoToJSON(json: any): CategoryDto {
    return CategoryDtoToJSONTyped(json, false);
}

export function CategoryDtoToJSONTyped(value?: CategoryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'description': value['description'],
        'parentId': value['parentId'],
        'parentName': value['parentName'],
    };
}

